import PropTypes from 'prop-types';
import Link from 'next/link';
// Utils
import { cn } from 'utils';
// Styles
import styles from './BreadCrumb.module.css';

function BreadCrumb({
  items, className, theme, noPadding,
}) {
  return (
    <section
      className={cn([styles.section, styles[theme], noPadding && styles.noPadding, className])}
    >
      <ol className={cn([styles.list])} itemScope itemType="http://schema.org/BreadcrumbList">
        {items.map((listItem, index) => (
          <li
            key={listItem.name}
            itemProp="itemListElement"
            itemScope
            itemType="http://schema.org/ListItem"
            className={styles.item}
          >
            {index === items.length - 1
              ? (<span itemProp="name">{listItem.name}</span>)
              : (
                <Link className={styles.link} itemProp="item" href={listItem.item}>
                  <span itemProp="name">{listItem.name}</span>
                </Link>
              )}

            <meta itemProp="position" content={listItem.position} />
          </li>
        ))}
      </ol>
    </section>
  );
}

BreadCrumb.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    position: PropTypes.number.isRequired,
    item: PropTypes.string,
  })),
  theme: PropTypes.oneOf(['transparent', 'light']),
  className: PropTypes.string,
  noPadding: PropTypes.bool,
};

BreadCrumb.defaultProps = {
  items: [],
  theme: 'light',
  className: null,
  noPadding: false,
};

export default BreadCrumb;
